import { render, staticRenderFns } from "./ListPax.vue?vue&type=template&id=39987159&scoped=true"
import script from "./ListPax.vue?vue&type=script&lang=js"
export * from "./ListPax.vue?vue&type=script&lang=js"
import style0 from "./ListPax.vue?vue&type=style&index=0&id=39987159&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39987159",
  null
  
)

export default component.exports